import React, { useEffect, useState } from "react";
import * as Style from "./styles/items";
// import { useLocation } from "react-router-dom";
import { MODULE_API } from "../../../../../apis";
// import { Button } from "../../../../styled-components/button";
import { Button, Modal } from "antd";
import "../../../../../components/form/inventory/inventory.style.css";
import StyledRow from "../../../../styled-components/styled-row/styled-row";
import { useSelector } from "react-redux";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import { Text } from "../../../../styled-components/text";
import AddSimpleModal from "../../../../styled-components/modal/add-simple-modal/add-simple-modal";
import IconInput from "../../../../styled-components/input/icon-input";
import addIcon1 from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import tableimg from "../../../../../assets/images/big/camera.png";
import { saveAs } from 'file-saver'
import swal from "sweetalert";
import axios from "axios";
import Loader from "../../../../styled-components/loader/loader";
import { formatCurrencyAmount } from "../../../../../helpers/formatAmount";

function Items() {
  const [isLoading, setIsLoading] = useState(false);
  const [itemsToshow, setItemsToShow] = useState();
  const [allItems, setAllItems] = useState([]);
  const [message, setMessage] = useState("");
  const [parentId, setParentId] = useState();
  const [parentImage, setParentImage] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState();
  const [collectibleValue, setCollectibleValue] = useState();
  const [itemsData, setItemsData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modal, setModal] = useState("");
  const [attributesFields, setAttributesFields] = useState();
  const [selectedRowData, setSelectedRowData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [detailsModal, setDetailsModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [activeTab, setActiveTab] = useState("addSingleItem");
  const { styles } = defaultStyles;

  //   const location = useLocation();
  const selectedModuleName = useSelector(
    (state) => state.rootReducer.inventory.selectedModuleName
  );
  //   console.log("location mdoule name", location.moduleName);

  const fetchItems = async (page) => {
    try {
      setIsLoading(true);
      let itemsResponce = await MODULE_API.fetchItems({
        moduleName: `${selectedModuleName}_item`,
        pageNum: page,
        limit: 10,
        body: {},
      });
      console.log("item", itemsResponce);

      setIsLoading(false);
      if (itemsResponce.status === 200) {
        setMessage(itemsResponce.messageCode);
        // setAllItems(itemsResponce.records);
        if (itemsResponce.records) {
          setAllItems((prevItems) => [...prevItems, ...itemsResponce.records]);
          setTotalPages(
            Math.ceil(
              itemsResponce.pagination.total &&
                itemsResponce.pagination.total / 10
            )
          );
          console.log("pageNumer", page);
          setCurrentPage(page);
        }
        let itemsRecodsToShow = itemsResponce.records.map((itemsRecord) => ({
          "Item Name": itemsRecord["Item Name"],
          Quantity: itemsRecord.Quantity,
          "Price Paid (each)":
            itemsRecord["Price Paid (each)"] || itemsRecord["Price Paid"],
          "Storage Loaction": itemsRecord["Storage Location"],
          "Updated Value":
            itemsRecord["Update Value (Appraisal or other method, each)"],
          "Est. Total Current value":
            itemsRecord["Estimated Total Current Value"],
        }));
        console.log("itemsRecodsToShow", itemsRecodsToShow);
        const paginationData = itemsResponce.pagination;
        setItemsToShow({
          ["pagination"]: { ...paginationData },
          ["itemsRecords"]: [...itemsRecodsToShow],
        });
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const fetchItemsWithoutUnderscore = async () => {
    try {
      setIsLoading(true);
      let itemsResponce = await MODULE_API.fetchItems({
        moduleName: `${selectedModuleName}`,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      console.log("item without underscore", itemsResponce.status);

      if (itemsResponce.status == 200) {
        console.log("abcccc");
        // setIsLoading(false);
        setParentId(itemsResponce.records[0].id);
        if (itemsResponce.records && itemsResponce.records[0]) {
          setParentImage(itemsResponce.records[0].image);
        }
        // fetchRecordTotal(itemsResponce.records[0].id);
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const handleItemsInfo = (obj) => {
    const { name, value } = obj;
    let allData = {
      ...itemsData,
      [name]: value,
    };

    if (name === "Price Paid (each)" || name === "Quantity") {
      let totalPaid = 0;
      if (name === "Price Paid (each)") {
        totalPaid = +itemsData["Quantity"] * value;
      } else {
        console.log(
          "here in else",
          itemsData["Quantity"],
          itemsData["Price Paid (each)"]
        );
        totalPaid = value * +itemsData["Price Paid (each)"];
      }
      // console.log("itemsDataNew",itemsData["Quantity"],itemsData["Price Paid (each)"])
      // let totalNew=(+itemsData["Quantity"]) * (+itemsData["Price Paid (each)"]);
      console.log("totalPaid", totalPaid, isNaN(totalPaid));
      // setItemsData({
      //   ...itemsData,
      //   ["Total Paid"]: totalPaid,
      // });
      if (isNaN(totalPaid)) {
        itemsData["Total Paid"] = 0;
        selectedRowData["Total Paid"] = 0;
      } else {
        itemsData["Total Paid"] = totalPaid;
        selectedRowData["Total Paid"] = totalPaid;
      }
      // setSelectedRowData({
      //   ...selectedRowData,
      //   ["Total Paid"]: totalPaid,
      // });
      const estimatedCurrentValue =
        allData["Quantity"] * itemsData["Total Paid"];
      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;
      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    } else if (name === "Update Value (Appraisal or other method, each)") {
      let estimatedCurrentValue = null;
      if (value === "" || value === 0) {
        estimatedCurrentValue = allData["Quantity"] * itemsData["Total Paid"];
      } else {
        estimatedCurrentValue = allData["Quantity"] * value;
      }

      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;

      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    }

    setItemsData({
      ...itemsData,
      [name]: value,
    });
    setSelectedRowData({
      ...selectedRowData,
      [name]: value,
    });
  };
  const handleItemsInfoSelect = (name, value) => {
    // console.log("in func");

    // const { name, value } = obj;

    if (name === "Price Paid (each)") {
      const totalPaid = itemsData["Quantity"] * value;
      // console.log("totalPaid",totalPaid);
      // setItemsData({
      //   ...itemsData,
      //   ["Total Paid"]: totalPaid,
      // });
      itemsData["Total Paid"] = totalPaid;
      selectedRowData["Total Paid"] = totalPaid;
      // setSelectedRowData({
      //   ...selectedRowData,
      //   ["Total Paid"]: totalPaid,
      // });
      const estimatedCurrentValue =
        itemsData["Quantity"] * itemsData["Total Paid"];
      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;
      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    } else if (name === "Update Value (Appraisal or other method, each)") {
      let estimatedCurrentValue = null;
      if (value === "" || value === 0) {
        estimatedCurrentValue = itemsData["Quantity"] * itemsData["Total Paid"];
      } else {
        estimatedCurrentValue = itemsData["Quantity"] * value;
      }

      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;

      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    }

    setItemsData({
      ...itemsData,
      [name]: value,
    });
    setSelectedRowData({
      ...selectedRowData,
      [name]: value,
    });
  };
  const handleItemsInfoImageChange = async (obj) => {
    console.log("obj image", obj);
    try {
      setIsLoading(true);
      const imageName = obj.files[0];
      let uploadImg = null;
      let formData = new FormData();
      formData.append("image", imageName);

      // new code signedURL
      const existingImages = Array.isArray(itemsData[obj.name])
        ? itemsData[obj.name]
        : [];

      const name = obj.files[0].name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      itemsData["File Name"] = fileName;
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: obj.files[0].type,
      });
      const resupload = await axios.put(resdata.uploadUrl, obj.files[0], {
        headers: { "Content-type": obj.files[0].type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log(res);

      uploadImg = res;
      console.log(res, "upload res");
      console.log("itemm", itemsData, existingImages);
      itemsData[obj.name] = [...existingImages, res];
      // itemsData[obj.name] = [res];
      setIsLoading(false);

      // let img = await MODULE_API.uploadImage(formData);
      // if (img && img.status === 200) {
      //   uploadImg = img.file_url;
      //   // setItemsData({
      //   //   ...itemsData,
      //   //   [imageName]: uploadImg,
      //   // });
      //   itemsData[obj.name] = [uploadImg];
      //   setIsLoading(false);
      // }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };
  function handleImageDelete(e, item, name) {
    e.preventDefault();

    const updatedImages =
      selectedRowData && Array.isArray(selectedRowData[name])
        ? selectedRowData[name].filter((img) => img !== item)
        : [];

    setItemsData((prev) => ({
      ...prev,
      [name]: updatedImages,
    }));

    setSelectedRowData((prev) => ({
      ...prev,
      [name]: updatedImages,
    }));
  }

  const fetchAttributes = async () => {
    try {
      setIsLoading(true);
      let attributesResponce = await MODULE_API.fetchAttributes(
        `${selectedModuleName}_item`
      );
      console.log("attributes responce", attributesResponce);
      setAttributesFields(attributesResponce);

      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const fetchRecordTotal = async (recordId) => {
    try {
      setIsLoading(true);
      const recordTotalPayload = {
        attributes: ["Estimated Total Current Value"],
      };
      const recordTotalResponce = await MODULE_API.getRecordTotal(
        recordId,
        recordTotalPayload
      );
      if (recordTotalResponce.status === 200) {
        setCollectibleValue(recordTotalResponce.data.total);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };
  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      document.getElementById("cards-main");
    // console.log("Scroll Top:", scrollTop);
    // console.log("Scroll Height:", scrollHeight);
    // console.log("Client Height:", clientHeight);

    if (scrollTop + clientHeight >= scrollHeight) {
      // console.log("Bottom of the scroll reached.");
      // console.log("pageee", currentPage, totalPages);
      if (currentPage < totalPages) {
        console.log("Fetching more items...");
        fetchItems(currentPage + 1);
      }
    }
  };

  // Add scroll event listener when component mounts
  // useEffect(() => {
  //   console.log("Attaching scroll event listener.");
  //   const cardsMainElement = document.getElementById("cards-main");
  //   cardsMainElement.addEventListener("scroll", handleScroll);
  //   return () => {
  //     console.log("Removing scroll event listener.");
  //     cardsMainElement.removeEventListener("scroll", handleScroll);
  //   };
  // }, [currentPage, totalPages]);
  useEffect(() => {
    // fetchItems();
    // fetchItemsWithoutUnderscore();
    // fetchAttributes();
    fetchAll();
  }, []);
  const fetchAll = async () => {
    await fetchItems(1);
    await fetchItemsWithoutUnderscore();
    await fetchAttributes();
  };
  const handelCloseModal = () => {
    setShowModal(false);
    setActiveTab("addSingleItem");
  };
  const downloadSampleFile = async () => {
    setIsLoading(true);
    setShowModal(false);
    setActiveTab("addSingleItem");
    try {
      const response = await MODULE_API.fetchSampleFile(selectedModuleName);
      console.log("ressssssss",response)
      if (response && response.fileUrl) {
        saveAs(response.fileUrl, `${selectedModuleName}_sample`);
      }
      setIsLoading(false);
      setShowModal(false);
      setActiveTab("addSingleItem");
    } catch (error) {
      console.log('err', error);
       setIsLoading(false);
      if (error.response) {
          setShowModal(false);
          setActiveTab("addSingleItem");
          swal("Error",error.response.data.message || "Some thing went wrong!", "error")

      }
    }
  };
  const uploadCollection = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setShowModal(false);
    setActiveTab("addSingleItem");
    try {
      const formData = new FormData();
      formData.append('file', e.target.files[0])
      const response = await MODULE_API.uploadCollectionFile(formData,selectedModuleName);
      // console.log("ressssssss",response)
      if (response && response.statusCode===201) {
        swal("Success!", "You Collection data has been saved!", "success")
        setAllItems([]);
        await fetchItems(1);
      }
      setIsLoading(false);
      setShowModal(false);
      setActiveTab("addSingleItem");
    } catch (error) {
      console.log('err', error);
       setIsLoading(false);
      if (error.response) {
          setShowModal(false);
          setActiveTab("addSingleItem");
          swal("Error",error.response.data.message || "Some thing went wrong!", "error")

      }
    }
  };
  const getSelectedRecords = async (record, name) => {
    setDetailsModal(true);
    console.log("record to edit", record);
    if (name === "Images") {
      setCurrentRecord({
        files: record.Image ? record.Image : [],
        name: name,
      });
    } else {
      setCurrentRecord({
        files: record.videos ? record.videos : [],
        name: name,
      });
    }
  };
  const handleCancel = () => {
    setCurrentRecord(null);
    setDetailsModal(false);
    setActiveTab("addSingleItem");
  };

  const submitData = async () => {
    try {
      console.log("in items submit data", itemsData);
      setIsLoading(true);
      let itemsDataCopy = { ...itemsData };
      itemsDataCopy["parentId"] = parentId;
      if (!itemsData["Estimated Total Current Value"]) {
        itemsDataCopy["Estimated Total Current Value"] = 0;
      }
      const payload = {
        clientModules: [itemsDataCopy],
      };
      console.log("payload", payload);

      if (modal === "Add Modal") {
        const res = await MODULE_API.createClientItem(
          `${selectedModuleName}_item`,
          payload
        );
        setIsLoading(false);
        setShowModal(false);
        setAllItems([]);
        fetchItems(1);
        fetchItemsWithoutUnderscore();
        // if (res.messageCode === "client.module.created") {

        //   fetchItems();
        //   fetchItemsWithoutUnderscore();
        //   // fetchRecordTotal(parentId);
        // }
      } else if (modal === "Update Modal") {
        const res = await MODULE_API.updateClientItem(
          selectedItemId,
          itemsData
        );

        // if (res.status === 200) {
        setIsLoading(false);
        setShowModal(false);
        setAllItems([]);
        await fetchItems(1);
        await fetchItemsWithoutUnderscore();

        // fetchRecordTotal(parentId);
        // }
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
     setActiveTab("addSingleItem");
  };

  const handleAddItem = async () => {
    setShowModal(true);
    setSelectedRowData({});
    setItemsData({});
    setModal("Add Modal");
    // try {
    //   setIsLoading(true);
    //   let attributesResponce = await MODULE_API.fetchAttributes(
    //     `${selectedModuleName}_item`
    //   );
    //   console.log("attributes responce", attributesResponce);
    //   setAttributesFields(attributesResponce);
    //   setShowModal(true);
    //   setIsLoading(false);
    // } catch (e) {
    //   setIsLoading(false);
    // }
  };

  const getSelectedRow = async (id) => {
    try {
      setModal("Update Modal");

      const selectedRow =
        allItems &&
        allItems.filter((data, index) => {
          if (index === id) {
            return data;
          }
        });

      setSelectedItemId(selectedRow[0].id);

      delete selectedRow[0].id;
      delete selectedRow[0].isShared;
      delete selectedRow[0].module;

      // const pd = selectedRow[0]["Purchase Date"];
      // const date = new Date(pd);
      // /* Date converted to YYYY-MM-DD format */
      // const pdDateMDY = `${date.getFullYear()}-${date.getDate()}-${
      //   date.getMonth() + 1
      // }`;
      // selectedRow[0]["Purchase Date"] = pdDateMDY;

      setSelectedRowData(selectedRow[0]);
      // setSelectedRowData((current) => {
      //   // 👇️ remove id,isShared,module key from object
      //   const { id, isShared, module, ...rest } = current;

      //   return rest;
      // });
      setShowModal(true);
      setItemsData(selectedRow[0]);
    } catch (e) {
      console.log(e);
    }
  };
  const handleView = (id) => {
    try {
      setModal("View Item");
      const selectedRow =
        allItems &&
        allItems.filter((data, index) => {
          if (index === id) {
            return data;
          }
        });

      setSelectedItemId(selectedRow[0].id);

      delete selectedRow[0].id;
      delete selectedRow[0].isShared;
      delete selectedRow[0].module;
      setSelectedRowData(selectedRow[0]);
      setShowModal(true);
      setItemsData(selectedRow[0]);
    } catch (e) {
      console.log(e);
    }
  };

  const deleteRow = async (id) => {
    try {
      const selectedRow =
        allItems &&
        allItems.filter((data, index) => {
          if (index === id) {
            return data;
          }
        });

      console.log("selectedRow to delete", selectedRow);
      const payload = {
        clientModules: [selectedRow[0].id],
      };

      swal({
        title: "Are you sure?",
        text: "You want to delete this item.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          setIsLoading(true);
          let res = await MODULE_API.deleteItem(payload);
          if (res && res.status === 200) {
            setIsLoading(false);
            setAllItems([]);
            await fetchItems(1);
            if (parentId) {
              //  await fetchRecordTotal(parentId);
            }
          }
        } else {
          // swal("Your imaginary file is safe!");
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  console.log("itemsData", itemsData);
  console.log("selected row data", selectedRowData);
  console.log("parentId", parentId);
  console.log("allItems", allItems);
  const isImage = (url) => {
    const imageExtensions = [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".bmp",
      ".webp",
      ".svg",
    ];
    return imageExtensions.some((ext) => url.toLowerCase().endsWith(ext));
  };
  return (
    <>
      {/* {isLoading ? <div class="loader" ng-hide="data.length > 0"></div> : null} */}

      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            //   rowGap: "1rem",
            marginTop: "2rem",
          }}
        >
          {/* <p
            style={{
              fontSize: "1.5rem",
              backgroundColor: "#4cba5b",
              fontFamily: "Poppins",
              color: "white",
              padding: "0.5rem 2rem",
              borderTopLeftRadius: "50%",
            }}
          >
            {selectedModuleName}
          </p>
          <div style={{ fontSize: "1.2rem", fontFamily: "Poppins" }}>
            <span
              style={{
                fontWeight: "bold",
                fontSize: "1.4rem",
                fontFamily: "Poppins",
              }}
            >
              Total Items :{" "}
            </span>{" "}
            {itemsToshow && itemsToshow.pagination.total}
          </div>
          <div
            style={{
              fontSize: "1.2rem",
              marginBottom: "2rem",
              fontFamily: "Poppins",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                fontSize: "1.4rem",
                fontFamily: "Poppins",
              }}
            >
              Collectible Value :{" "}
            </span>
            {collectibleValue && collectibleValue}
            </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "0rem 1rem",
            }}
          >
            <div>
              {" "}
              <h3
                style={{
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  fontSize: "20px",
                }}
              >
                {selectedModuleName}
              </h3>
            </div>
            <Style.FieldsContainer
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom:"8px",
              }}
            >
              <h3 style={{ fontFamily: "Poppins", fontSize: "20px" }}>
                Add New {selectedModuleName}
              </h3>
              <div
                className="upload"
                onClick={handleAddItem}
                style={{ width: "28px", height: "28px", cursor: "pointer" }}
              >
                <img
                  src={addIcon1}
                  width={12}
                  height={12}
                  style={{ width: "16px", height: "16px" }}
                  alt="addicon"
                ></img>
              </div>
              {/*  <Button style={styles.button.sqaureButton} onClick={handleAddItem}>
              +
            </Button>*/}
            </Style.FieldsContainer>
          </div>
          {message &&
          (itemsToshow === undefined ||
            itemsToshow.itemsRecords.length === 0) ? (
            <div
              style={{ fontSize: "1.7rem", marginTop: "2rem", color: "black" }}
            >
              {" "}
              No Data Found
            </div>
          ) : null}

          {/* <Style.Title>Items</Style.Title> */}
          {/* <Button>Add Item</Button> */}
        </div>

        <Style.CardContainer>
          <Style.CardsMain
            style={{
              justifyContent:
                allItems && allItems.length > 0 ? "start" : "center",
              grid: allItems && allItems.length === 0 && "initial",
              padding: "2rem 10px",
              gap: "1rem",
              maxHeight: "calc(100vh - 217px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
            id="cards-main"
            onScroll={handleScroll}
          >
            {/* {allProperties? allProperties.length >0: <p>No record found.</p>} */}
            {allItems && allItems.length > 0
              ? allItems.map((item, index) => (
                  <Style.Card
                    key={index}
                    style={{ padding: "0" }}
                  >
                    {/* Image Section */}
                    <div
                      style={{
                        padding: "1.5rem 1rem 0.5rem",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        height: "220px",
                        alignItems: "center",
                      }}
                    >
                      <Style.Img
                        src={
                          item.Image && item.Image[0] && isImage(item.Image[0])
                            ? item.Image[0]
                            : parentImage || `${tableimg}`
                        }
                        style={{
                          width: "auto",
                          height: "100%",
                          maxHeight: "200px",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Image Gallery Button - Centered Below Image */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "0.5rem 0",
                      }}
                    >
                      <Button
                        type="link"
                        style={{ fontSize: "21px", color: "#2a3da3" }}
                        icon="file-image"
                        onClick={(e) => {
                          e.stopPropagation();
                          getSelectedRecords(item, "Images");
                        }}
                      />
                    </div>

                    {/* Header: Title and Actions */}
                    <Style.CardHeader>
                      <Style.CardTitle>
                        {item["Item Name"] ? item["Item Name"] : "N/A"}
                      </Style.CardTitle>
                      <Style.CardIcons>
                        <Button
                          type="link"
                          icon="edit"
                          style={{ color: "black", fontSize: "18px" }}
                          onClick={() => {
                            getSelectedRow(index);
                          }}
                        />
                        <Button
                          type="link"
                          icon="eye"
                          style={{ color: "black", fontSize: "18px" }}
                          onClick={() => {
                            handleView(index);
                          }}
                        />
                        <Button
                          type="link"
                          icon="delete"
                          style={{ color: "black", fontSize: "18px" }}
                          onClick={() => deleteRow(index)}
                        />
                      </Style.CardIcons>
                    </Style.CardHeader>

                    {/* Main Value Section */}
                    <Style.CardValueSection>
                      <Style.CardValue>
                        {item["Estimated Total Current Value"]
                          ? formatCurrencyAmount(item["Estimated Total Current Value"])
                          : "$0.00"}
                      </Style.CardValue>
                      <Style.CardLabel>Total Paid</Style.CardLabel>
                    </Style.CardValueSection>

                    {/* Footer Stats */}
                    <Style.StatsContainer>
                      <Style.StatBox>
                        <Style.StatLabel>Price Paid (each)</Style.StatLabel>
                        <Style.StatValue>
                          {item["Price Paid (each)"] || item["Price Paid"]
                            ? (item["Price Paid (each)"] &&
                                formatCurrencyAmount(
                                  item["Price Paid (each)"]
                                )) ||
                              (item["Price Paid"] &&
                                formatCurrencyAmount(item["Price Paid"]))
                            : "N/A"}
                        </Style.StatValue>
                      </Style.StatBox>

                      <Style.StatBox>
                        <Style.StatLabel>Quantity</Style.StatLabel>
                        <Style.StatValue>
                          {item.Quantity ? item.Quantity : "N/A"}
                        </Style.StatValue>
                      </Style.StatBox>

                      <Style.StatBox last>
                        <Style.StatLabel>Storage Location</Style.StatLabel>
                        <Style.StatValue
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100px",
                          }}
                          title={
                            item["Storage Location"]
                              ? item["Storage Location"]
                              : "N/A"
                          }
                        >
                          {item["Storage Location"]
                            ? item["Storage Location"]
                            : "N/A"}
                        </Style.StatValue>
                      </Style.StatBox>
                    </Style.StatsContainer>
                  </Style.Card>
                ))
              : null}
          </Style.CardsMain>
          {/*
          {itemsToshow &&
            itemsToshow.itemsRecords.map((item, index) => (
              <StyledRow
                key={index}
                item={item}
                allItems={allItems}
                getSelectedRow={getSelectedRow}
                deleteRow={deleteRow}
                index={index}
                image="required"
              />
            ))} */}
        </Style.CardContainer>
      </div>
      <AddSimpleModal
        show={showModal}
        close={handelCloseModal}
        modalTitle={
          modal === "Add Modal"
            ? "Add Item"
            : modal === "Update Modal"
            ? "Update Item"
            : modal === "View Item"
            ? "View Item"
            : ""
        }
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        fields={attributesFields}
        downloadSampleFile={downloadSampleFile}
        uploadCollection={uploadCollection}
        onChange={handleItemsInfo}
        onSelectChange={handleItemsInfoSelect}
        submitData={submitData}
        selectedRowData={selectedRowData}
        handleItemsInfoImageChange={handleItemsInfoImageChange}
        handleImageDelete={handleImageDelete}
        loading={isLoading}
      />
      <Modal
        visible={detailsModal}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={true}
        centered
        // width={800}
        bodyStyle={{
          padding: 0,
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            // background: "linear-gradient(135deg, #2a3da3 0%, #1e2d7a 100%)",
            padding: "1.5rem 2rem",
            // color: "white",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "1.5rem",
              fontWeight: "600",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            {selectedModuleName} Gallery
          </h2>
          <p
            style={{
              margin: "0.5rem 0 0 0",
              fontSize: "0.9rem",
              opacity: 0.9,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            {currentRecord && currentRecord.name} Details
          </p>
        </div>

        {/* Modal Body */}
        <div style={{ padding: "2rem" }}>
          <div
            style={{
              maxHeight: "500px",
              overflow: "auto",
              paddingRight: "0.5rem",
            }}
          >
            {currentRecord && currentRecord.files.length > 0 ? (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: "1.5rem",
                }}
              >
                {currentRecord.name === "Images" &&
                  currentRecord.files.map((imgUrl, index) => (
                    <a
                      key={index}
                      href={imgUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        position: "relative",
                        display: "block",
                        borderRadius: "12px",
                        overflow: "hidden",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 20px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 12px rgba(0,0,0,0.1)";
                      }}
                    >
                      <img
                        src={imgUrl}
                        alt={`Image ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          background:
                            "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                          padding: "1rem 0.75rem 0.5rem",
                          color: "white",
                          fontSize: "0.85rem",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        Image {index + 1}
                      </div>
                    </a>
                  ))}
                {currentRecord.name === "Videos" &&
                  currentRecord.files.map((videoUrl, index) => {
                    const getVideoType = (url) => {
                      const ext = url.split(".").pop().toLowerCase();
                      const types = {
                        mp4: "video/mp4",
                        webm: "video/webm",
                        ogg: "video/ogg",
                        mov: "video/quicktime",
                      };
                      return types[ext] || "video/mp4";
                    };

                    return (
                      <div
                        key={index}
                        style={{
                          borderRadius: "12px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <video
                          controls
                          style={{
                            borderRadius: "12px",
                            width: "100%",
                            display: "block",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                            document.getElementById(
                              `fallback-${index}`
                            ).style.display = "block";
                          }}
                        >
                          <source
                            src={videoUrl}
                            type={getVideoType(videoUrl)}
                          />
                          Your browser does not support the video tag.
                        </video>
                        <div
                          id={`fallback-${index}`}
                          style={{
                            display: "none",
                            padding: "2rem",
                            textAlign: "center",
                            backgroundColor: "#fff3cd",
                            borderRadius: "12px",
                          }}
                        >
                          <p
                            style={{
                              color: "#856404",
                              margin: "0 0 1rem 0",
                              fontFamily: "Poppins, sans-serif",
                            }}
                          >
                            ⚠️ Video format not supported.
                          </p>
                          <button
                            onClick={async () => {
                              try {
                                const response = await fetch(videoUrl);
                                const blob = await response.blob();
                                const blobUrl =
                                  window.URL.createObjectURL(blob);
                                const a = document.createElement("a");
                                a.href = blobUrl;
                                a.download = `video-${index}`;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(blobUrl);
                              } catch (error) {
                                alert("Failed to download video.");
                                console.error("Download error:", error);
                              }
                            }}
                            style={{
                              backgroundColor: "#2a3da3",
                              color: "white",
                              padding: "0.5rem 1.5rem",
                              border: "none",
                              borderRadius: "6px",
                              cursor: "pointer",
                              fontFamily: "Poppins, sans-serif",
                              fontSize: "0.9rem",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#1e2d7a";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "#2a3da3";
                            }}
                          >
                            Download Video
                          </button>
                        </div>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "3rem",
                  color: "#999",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>
                  📷
                </div>
                <h3 style={{ margin: 0, color: "#666" }}>No Data to Show</h3>
                <p style={{ margin: "0.5rem 0 0 0", fontSize: "0.9rem" }}>
                  No images or videos available
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div
          style={{
            padding: "1rem 2rem",
            borderTop: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#fafafa",
          }}
        >
          <button
            onClick={() => {
              handleCancel();
            }}
            style={{
              backgroundColor: "#2a3da3",
              color: "white",
              padding: "0.75rem 2.5rem",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontFamily: "Poppins, sans-serif",
              fontSize: "1rem",
              fontWeight: "500",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 8px rgba(42, 61, 163, 0.2)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#1e2d7a";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(42, 61, 163, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#2a3da3";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 2px 8px rgba(42, 61, 163, 0.2)";
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      <Loader isLoading={isLoading} />
    </>
  );
}

export default Items;
